import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Add } from "@mui/icons-material";
import { Icon } from "@mui/material";
import utils from "Root/profile/utils";
import styles from "../SubscriptionItem/styles.module.scss";
import UnderlinedButton from "../../common/UnderlinedButton";
import productSummaryBlockStyles from "Root/quiz/components/ProductSummaryBlock/styles.module.css";
import Eyebrow from "../../common/Eyebrow";
import SmallFont from "../../common/SmallFont";
import RegFont from "../../common/RegFont";
import { useSelector } from "react-redux";
const RecommendedProduct = ({ title, image, onClick, net_price, price, product_key, subtitle, addon_info, deliveredEvery, }) => {
    const isByb = useSelector((state) => state.user.user_class === "byb");
    const onItemClick = (isMoreDetails) => {
        onClick && onClick(product_key, isMoreDetails);
    };
    const getQuanityString = (servings) => {
        if (utils.isFlavorBoost(product_key)) {
            return `1 Pack | 7 servings`;
        }
        if (["creatine", "preworkout", "collagen", "fiber"].includes(product_key)) {
            return `1 Jar | ${servings}`;
        }
        return `1 Bag | ${servings}`;
    };
    const getCategory = () => {
        if (utils.getIsBooster(product_key)) {
            return "Performance Boost";
        }
        if (utils.isFlavorBoost(product_key)) {
            return "Flavor Boost";
        }
        if (utils.isAdditionalItem(product_key)) {
            return "Accessory";
        }
        if (product_key === "greens") {
            return "";
        }
        return product_key === "greens"
            ? " "
            : !isByb
                ? "Personalized"
                : "Customized";
    };
    const getTitle = () => {
        if (utils.getIsBooster(product_key)) {
            return title.replace("Performance Boosts", "");
        }
        return title;
    };
    const showQty = product_key !== "blenderbottle" &&
        product_key !== "waterbottle" &&
        product_key !== "wb221" &&
        product_key !== "wb222";
    return (_jsxs("div", { className: `${styles.subscription_item} ${styles.subscription_item_edit}`, children: [_jsxs("div", { className: styles.subscription_item_wrapper, children: [_jsx("div", { className: styles.subscription_item_img_wrapper, children: _jsx("img", { src: image, alt: title }) }), _jsxs("div", { className: styles.subscription_item_info, children: [getCategory() && _jsx(Eyebrow, { children: getCategory() }), _jsx(RegFont, { fontWeight: 400, children: getTitle() }), _jsx("span", { className: productSummaryBlockStyles.info, children: net_price === price ? (_jsx(SmallFont, { children: price })) : (_jsxs(_Fragment, { children: [_jsx("span", { className: productSummaryBlockStyles.old_price, children: _jsx(SmallFont, { children: price }) }), "\u00A0", _jsx("span", { className: productSummaryBlockStyles.discount, children: _jsx(SmallFont, { color: "#77b1ac", children: net_price }) })] })) }), utils.isAdditionalItem(product_key) && (_jsxs(SmallFont, { className: productSummaryBlockStyles.info, children: [addon_info, addon_info && _jsx(_Fragment, { children: "\u00A0|\u00A0" }), deliveredEvery] })), showQty && (_jsxs(SmallFont, { className: productSummaryBlockStyles.info, children: [_jsx("b", { children: "Quantity:\u00A0" }), getQuanityString(subtitle)] })), !utils.isAdditionalItem(product_key) && (_jsx(UnderlinedButton, { onClick: () => onItemClick(true), extraClassName: styles.more_details, label: "More Details", "data-attr": product_key + "more-details-button" }))] })] }), _jsx("div", { onClick: () => onItemClick(false), tabIndex: 0, role: "button", onKeyDown: () => null, className: styles.plus_button, "data-attr": product_key + "add-button", children: _jsx(Icon, { component: Add }) })] }));
};
export default RecommendedProduct;
